module.exports = __webpack_public_path__ + "static/img/medical_7.8d3bcc32.jpg";